import React, { Component } from 'react';
import { View, FlatList, StyleSheet } from 'react-native';
import R from '../../../core-res/R';
import { getListItemStyle, getTextWrapperStyle, getIndicatorPosition } from '../utils/getStyle';
import IndexIndicator from '../commonComponents/IndexIndicator';
import EventText from '../commonComponents/EventText';
import { keyExtractor } from '../utils/BreadCrumbUtils';
import { VERTICAL_LINE_WIDTH } from '../utils/BreadCrumbConst';
class VerticalBreadCrumb extends Component {
    constructor() {
        super(...arguments);
        this.renderLastItemPaddingView = () => {
            const { theme } = this.props;
            const borderColor = theme.lightPrimary;
            return <View style={[staticStyles.paddingView, { borderColor }]}/>;
        };
        this.renderIndexIndicator = index => {
            const { themeVariant, activeEventIndex, theme } = this.props;
            const style = getIndicatorPosition(index);
            return (<IndexIndicator theme={theme} activeEventIndex={activeEventIndex} themeVariant={themeVariant} index={index} style={style}/>);
        };
        this.renderItemText = (item, index) => {
            const { themeVariant, activeEventIndex, theme } = this.props;
            return (<EventText theme={theme} themeVariant={themeVariant} activeEventIndex={activeEventIndex} text={item} index={index}/>);
        };
        this._renderItem = ({ item, index }) => {
            const { theme, events } = this.props;
            const backgroundColor = theme.brand;
            const borderColor = theme.lightPrimary;
            return (<View style={[staticStyles.listItem, { backgroundColor }, getListItemStyle(index, events.length - 1)]}>
        {this.renderIndexIndicator(index)}
        <View style={[staticStyles.listTextWrapper, getTextWrapperStyle(index, events.length - 1), { borderColor }]}>
          {index === events.length - 1 && this.renderLastItemPaddingView()}
          {this.renderItemText(item, index)}
        </View>
      </View>);
        };
    }
    render() {
        const { events, theme } = this.props;
        return (<View key={theme.lightPrimary} style={{ paddingVertical: R.spacing.xs, backgroundColor: theme.brand }}>
        <FlatList keyExtractor={keyExtractor} data={events} renderItem={this._renderItem} showsVerticalScrollIndicator={false}/>
      </View>);
    }
}
const staticStyles = StyleSheet.create({
    listItem: {
        paddingHorizontal: R.spacing.l,
    },
    listTextWrapper: {
        borderLeftWidth: VERTICAL_LINE_WIDTH,
        zIndex: -1,
        paddingLeft: R.spacing.xs,
    },
    paddingView: {
        height: R.spacing.xs,
        borderLeftWidth: VERTICAL_LINE_WIDTH,
        left: 0,
        position: 'absolute',
        top: 0,
    },
});
export default VerticalBreadCrumb;
